import { Fragment, useEffect } from "react";

import Button from "../../../components/Button/Button";
import Centered from "../../../components/Centered";
import Spacer from "../../../components/space/Spacer";
import Text from "../../../components/Text";
import { refreshOutgoingRequest } from "../../../data/tanstack-query";
import { getCandidates } from "../../../endpoints/outgoing-requests";
import { loggedInHomeRoute } from "../../../navigation/routes";
import { contactsRoute } from "../navigation";

export default function DoneStep() {
    useEffect(() => {
        void refreshOutgoingRequest(getCandidates());
    }, []);
    return (
        <Fragment>
            <Text variant="body" align="center">
                Cette personne a rejoint votre projet.
            </Text>
            <Spacer scale={8} />
            <Centered>
                <Button label="Retour aux contacts" action={contactsRoute.getLocation()} />
            </Centered>
            <Spacer scale={4} />
            <Centered>
                <Button
                    label="Aller à l'accueil"
                    feeling="minor"
                    role="minor"
                    action={loggedInHomeRoute.getLocation()}
                />
            </Centered>
        </Fragment>
    );
}
